import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaYoutube, FaExternalLinkAlt } from 'react-icons/fa';
import './Projects.css';

const Projects = () => {
  const projects = [


        {
  title: 'FinPay',
  image: 'finpay.jpg',
  github: 'https://github.com/shristi76/Finpay-Scalable-FinTech-Wallet-Payment-Backend',
  description: 'Scalable FinTech Wallet & Payment backend with JWT auth, wallet system, P2P transfers, MPIN security, and transaction history.',
  live: 'https://documenter.getpostman.com/view/46688304/2sBXwsMqXe'
  // youtube: ''
},
    {
      title: 'Real Time Chat Application',
      image: 'Chatroom.png',
      github: 'https://github.com/shristi76/ChatRoom-System',
      description: 'A real-time chat application with dynamic room creation and user management.',
      // youtube: 'xyz',
      live: 'https://chat-room-system-two.vercel.app'
    },
  


    
    {
      title: 'BookMyStay',
      image: 'download.jpg',
      github: 'https://github.com/shristi76/Bookmystay',
      description: 'Hotel booking platform with search, filtering, and reservation features.',
      live: 'https://documenter.getpostman.com/view/46688304/2sBXqRibmC'
      // youtube: 'kmn',
      
    },


    //   {
    //   title: 'Auth System',
    //   image: 'authhh.png',
    //   github: 'https://github.com/shristi76/auth_system',
    //   description: 'Secure authentication system with JWT tokens and password hashing.',
    //   // youtube: 'abc',
    //   // live: 'ing'
    // },
  
    // {
    //   title: 'AI Powered Logo Generator',
    //   image: 'ailogo.png',
    //   github: 'https://github.com/shristi76/AI-Powered-Logo-Generator',
    //   description: 'AI-driven logo generation tool using image generation model integration',
    //   // youtube: 'hgkmn',
    //   live: 'https://ai-powered-logo-generator-3.onrender.com/index.html'
    // },

    //   {
    //   title: 'Trackify',
    //   image: 'Trackify.png',
    //   github: 'https://github.com/shristi76/Trackify',
    //   description: 'Kanban board to track your work . It helps you organize tasks visually by moving them across different stages.',
    //   // youtube: 'hgkmn',
    //   live: 'https://iridescent-mooncake-ba8c33.netlify.app/'
    // },
   
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Projects</h2>
          <div className="underline"></div>
        </motion.div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <motion.div
              key={project.title}
              className="project-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03, y: -8 }}
            >
              {/* Image + Overlay */}
              <div className="project-image">
                <img src={`/${project.image}`} alt={project.title} />
                <div className="project-overlay">
                  <div className="project-links">
                    {project.github && (
                      <a
                        href={project.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="GitHub"
                        className="link-btn link-github"
                      >
                        <FaGithub />
                      </a>
                    )}
                    {project.youtube && (
                      <a
                        href={project.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="YouTube"
                        className="link-btn link-youtube"
                      >
                        <FaYoutube />
                      </a>
                    )}
                    {project.live && (
                      <a
                        href={project.live}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Live Demo"
                        className="link-btn link-live"
                      >
                        <FaExternalLinkAlt />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>

                {/* Footer icon row */}
                <div className="project-footer">
                  {project.github && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-link"
                      title="GitHub"
                    >
                      <FaGithub /> <span>Code</span>
                    </a>
                  )}
                  {project.youtube && (
                    <a
                      href={project.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-link footer-link--youtube"
                      title="Watch on YouTube"
                    >
                      <FaYoutube /> <span>Demo</span>
                    </a>
                  )}
                  {project.live && (
                    <a
                      href={project.live}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-link footer-link--live"
                      title="Live Site"
                    >
                      <FaExternalLinkAlt /> <span>Live</span>
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;